export enum SECURE_LOGIN_SYS_FLAG {
    FSA = 1,
    GRAD = 2,
}